import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-datepicker';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SchedulePlanningIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.availabilityLable = this.availabilityLable.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChangeDate (name, event) {
    var change = {};
    var full_date = this.state.date_start;
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
      var full_date = ("0"+day).slice(-2) + "/" + ("0"+month).slice(-2) + "/" + year;
      change[name] = date;
    }
    this.setState(change);
    this.loadData(full_date);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }
  
  componentWillMount () {
    var today = new Date();
    var date = today.setDate(today.getDate());
    var today_str = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd

    this.setState({date_start: today_str});
  }
  
  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escalas/programacao/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  availabilityLable (cell, row) {
    if (cell === 1) {
      var botao = (
        <span className="label label-success">{this.locale.Escalas.ListaDeEscalaDiaria.botaoDisponivel}</span>
      );
    } else {
      var botao = (
        <span className="label label-danger">{this.locale.Escalas.ListaDeEscalaDiaria.botaoIndisponivel}</span>
      );
    }

    return botao;
  }

  ActionsButtons (cell, row) {
    var edit = '/escala/programacao/editar/' + cell;

    var botao = (
      <div>
        <Link className={'btn btn-primary btn-sm'} to={edit}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>&nbsp;
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  duplicate() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/escala/programacao/duplicar';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      date: self.state.date_start,
    };
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/programacao/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  sendMail() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/escala/programacao/email';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/programacao/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var schedule_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Escalas.ListaDeEscalaDiaria.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/' + schedule_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(schedule_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(schedule_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == schedule_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.Escalas.ListaDeEscalaDiaria.titulo}</h3>
      <button className="btn btn-info pull-right button-inline" onClick={this.sendMail}><i className="fa fa-envelope"></i></button>
      <button className="btn btn-warning pull-right button-inline" onClick={this.duplicate}><i className="fa fa-refresh"></i> {this.state.next}</button>
      <Link to="/escala/programacao/cadastrar" className="btn btn-primary pull-right button-inline"><i className="fa fa-plus"></i> {this.locale.Escalas.ListaDeEscalaDiaria.botaoAdicionarProgramacao}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div className="clearfix"></div>
      <div className="row">
        <div className="col-md-2 col-md-offset-5">
          <div className="form-group">
            <input type="date" value={this.state.date_start} onChange={this.handleChangeDate.bind(this, 'date_start')} className="form-control" />
          </div>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Escalas.ListaDeEscalaDiaria.tabela.semProgramacaoParaHoje}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Base}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Modelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="contract" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Contrato}</TableHeaderColumn>
        <TableHeaderColumn dataField="availability" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250' dataFormat={this.availabilityLable}>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Disponibilidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="cmdts" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.ComandanteS}</TableHeaderColumn>
        <TableHeaderColumn dataField="copils" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.CopilotoS}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_attendants" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.ComissarioS}</TableHeaderColumn>
        <TableHeaderColumn dataField="group_starts" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Apresentacao}</TableHeaderColumn>
        <TableHeaderColumn dataField="group_finishes" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Corte}</TableHeaderColumn>
        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='200'>{this.locale.Escalas.ListaDeEscalaDiaria.tabela.Acoes}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulePlanningIndex;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulePlanningIndex.js